/**
 * Filter date file
 *
 * @package    DataTable
 * @author     Maxim Lukianenko <mlukianenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import DatePicker from 'material-ui-pickers/DatePicker';
import moment from 'moment';

import { DATA_TABLE_DATE_FORMAT } from 'Constants';
import { DataTableColumnType } from 'Types';

export default class FilterDate extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        column: DataTableColumnType,
        filter: PropTypes.any,
        setFilter: PropTypes.func.isRequired,
        placeholder: PropTypes.string,
        libraryParams: PropTypes.object,
        operator: PropTypes.string
    };

    /**
     * DefaultProps
     */
    static defaultProps = {
        libraryParams: {},
    };

    /**
     * Context Types
     *
     * @type Object
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    handleDateChange = date => {
        const { setFilter, operator } = this.props;
        setFilter(date ? date.format(DATA_TABLE_DATE_FORMAT) + (operator === 'gte' ? ' 00:00:00' : ' 23:59:59') : null);
    };

    getSelectedValue = () => {
        const { filter, operator } = this.props;
        let filterValue = null;

        if (filter) {
            if (operator) {
                filterValue = operator && filter.hasOwnProperty(operator) ? filter[operator] : null;
            } else {
                filterValue = filter;
            }
        }

        return filterValue ? moment(filterValue, DATA_TABLE_DATE_FORMAT) : null;
    };

    render() {
        const { placeholder, libraryParams } = this.props;
        const { intl: { formatMessage } } = this.context;
        return (
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                    emptyLabel={placeholder ? formatMessage({ id: placeholder }) : ''}
                    clearable
                    value={this.getSelectedValue()}
                    onChange={this.handleDateChange}
                    InputProps={ { className: 'mm-table-filter-date' } }
                    {...libraryParams}
                />
            </MuiPickersUtilsProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableFilters/Filters/FilterDate.jsx